export default __webpack_public_path__ + "static/media/eye-off.6dd7ac22.svg";